import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A month wasted",
  "description": "",
  "published": "2012-01-26T00:00:00.000Z",
  "redirect_from": ["/blog/a-month-wasted/swizec/3545"],
  "categories": "Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This post is about exams, being in college and jumping through `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Arbitrariness",
        "title": "Arbitrariness"
      }}>{`arbitrary`}</a>{` hoops set up by arbitrary old men so they can feel arbitrarily important. But most of all it's about everyone wasting a month of their lives for something that surely a better alternative exists for. I `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/i-suck-at-formal-education-or-does-education-suck/swizec/2564",
        "title": "I suck at [formal] education or does education suck?"
      }}>{`may`}</a>{` `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/a-longboard-and-a-school-system/swizec/2438",
        "title": "A longboard and a school system"
      }}>{`have`}</a>{` `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/doing-a-startup-taught-me-the-value-of-staying-in-school/swizec/1819",
        "title": "Doing a startup taught me the value of staying in school"
      }}>{`written`}</a>{` about this before.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/300px-University_of_Tokyo_Admittance_Celebrations_2011-03-10.jpg",
        "alt": "English: A crowd has gathered to take part of ...",
        "title": "English: A crowd has gathered to take part of ..."
      }}></img></p>
    <p>{`I am notorious for sucking at passing exams. I am perhaps even more notorious for disrespecting authority and arbitrary tests of skill. There might be some bias. You have been warned.`}</p>
    <p>{`My hate of tests started early, when I was doing those `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Test_%28assessment%29",
        "title": "Test (assessment)"
      }}>{`aptitude tests`}</a>{` for first grade I stopped after five minutes saying something like "Here. That's enough for you. Bye".`}</p>
    <p>{`When you do that at six the examiner goes `}<em parentName="p">{`"Oh my! What a smart little boy, so defiant and thinking for himself!"`}</em>{`, at 24 the usual reaction is more along the lines of `}<em parentName="p">{`"Omg what an idiot, who let him out of grade school? The guy can't even solve the simplest of problems!"`}</em></p>
    <p>{`However, exams are upon us and it is once more time to jump through hoops and prove ourselves worthy of being allowed to jump through some more hoops. Just so old men can pat each other on the back and feel good about having taught people something.`}</p>
    <h2 {...{
      "id": "a-waste-of-time"
    }}>{`A waste of time!`}</h2>
    <p>{`I don't think there's a single person in the world who likes exam season, not even the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Professor",
        "title": "Professor"
      }}>{`professors`}</a>{` and `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Teaching_assistant",
        "title": "Teaching assistant"
      }}>{`teaching assistants`}</a>{`. Just a week ago everyone's lives were better.`}</p>
    <p>{`The professors were working on their `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Research",
        "title": "Research"
      }}>{`research`}</a>{` and figuring out cool ways to impart `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Knowledge",
        "title": "Knowledge"
      }}>{`knowledge`}</a>{` on young impressionable minds. The teaching assistants were also working on their research, while doing a bit of slave work for the professors, imparting knowledge on young impressionable minds and possibly grading some homework.`}</p>
    <p>{`Most of the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Student",
        "title": "Student"
      }}>{`students`}</a>{`' lives revolved around going to class and having knowledge imparted on their young impressionable minds. Some of them were doing research on the side, or some sort of pet project or another, some have jobs - most of them working on exactly the kind of thing they'll be doing after they graduate - at least that's how it is in my line of work.`}</p>
    <p>{`The better students were also studying the more interesting subjects in more detail, because what is said in class just doesn't feed their hunger for knowledge.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/300px-StateLibQld_1_1003481.jpg",
        "alt": "English: School children doing exams inside a ...",
        "title": "English: School children doing exams inside a ..."
      }}></img></p>
    <p>{`Some of the students - there might be less of these now that I'm not a freshman anymore - had impressive WoW and `}<a parentName="p" {...{
        "href": "http://www.elderscrolls.com/",
        "title": "The Elder Scrolls V: Skyrim"
      }}>{`Skyrim`}</a>{` characters.`}</p>
    <p>{`Enter exam season, stage left, all our lives got twisted upside down.`}</p>
    <p>{`Suddenly everyone's productive lives are put on hold for a month while we take the time to jump through hoops and politely ask permission to jump through more.`}</p>
    <p>{`For a month:`}</p>
    <ul>
      <li parentName="ul">{`professors have to observe students jump through hoops instead of advancing their field`}</li>
      <li parentName="ul">{`teaching assistants must create those hoops and grade the jumping instead of doing research`}</li>
      <li parentName="ul">{`instead of going to cool lectures, students must study`}</li>
      <li parentName="ul">{`instead of being productive on cool projects, students must jump`}</li>
      <li parentName="ul">{`when a hoop is presented a student must not ask "Why the fuck?", no, they must ask "Can you please turn that on fire as well? And can I do a piruette through it please?"`}</li>
    </ul>
    <h2 {...{
      "id": "its-insane-and-stupid"
    }}>{`It's insane. And stupid.`}</h2>
    <p>{`You come there, often times early in the morning, and are given an exam. Then you are expected to solve four tasks. Each of them must be solved perfeclty on the first try. You have 90 minutes. Good luck.`}</p>
    <p>{`Remember how they say interviewing candidates should not be based on trivia knowledge or solving "simple" tasks perfectly on the first try under time and situation pressure? `}{`[`}<a parentName="p" {...{
        "href": "http://www.joelonsoftware.com/articles/fog0000000073.html"
      }}>{`Joel on Software - Guerrilla Guide to Interviewing`}</a>{`]`}</p>
    <p>{`Then why is it considered a good idea to test knowledge of `}{`_`}{`a whole subject`}{`_`}{` like that? There's no way a normal human being even stands a chance.`}</p>
    <p>{`I'm lying, of course there is.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/01/300px-Yushima_tenmangu_ema1.jpg",
        "alt": "English: A wall of \"ema\" votive plat...",
        "title": "English: A wall of \"ema\" votive plat..."
      }}></img></p>
    <p>{`When you dumb down the whole field into formulaic application of a few algorithms and memorizing a few equations, suddenly everything becomes testable like that. But is this really in the spirit of what we're trying to achieve here?`}</p>
    <p>{`I mean, we are, after all, trying to prove who is and who isn't worthy of being the creme of high thought in this nation and who gets to advance the field, funding for research, stuff like that.`}</p>
    <p>{`A bunch of mindless automatons following instructions and dutifully obeying authority are sure to do just that! Wait, why do we have computers again?`}</p>
    <p>{`I can understand this happening in high school ... a bit ... but college? Seriously? Your idea of a good `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Higher_education",
        "title": "Higher education"
      }}>{`college education`}</a>{` is making sure I know how to follow instructions and apply some basic proofs/algorithms/formulas by hand?`}</p>
    <p>{`Fuck. That. Shit.`}</p>
    <p>{`Is there a solution? I don't know, but I've always liked the idea of being given a semester to do a big project involving what we're being taught in class. It's a lot more interesting and a better way to learn about something.`}</p>
    <p>{`PS: there are many bright exceptions to this behavior at my college, it's just that none of those exams stick in memory because I pass them with a good grade almost without trying.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stcathmsrosette.wordpress.com/2012/01/25/memo-to-junior-4s-re-exams/"
        }}>{`Memo to Junior 4s re Exams`}</a>{` (stcathmsrosette.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://berbececristian.wordpress.com/2012/01/24/something-new/"
        }}>{`Something new`}</a>{` (berbececristian.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://nairanotes.wordpress.com/2011/11/22/common-mistakes-made-by-students-during-exam-period/"
        }}>{`Common Mistakes Made By Students During Exam Period`}</a>{` (nairanotes.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://thoughtofvg.wordpress.com/2012/01/17/first-postexams-and-what-they-are-good-for/"
        }}>{`First post/exams and what they are good for`}</a>{` (thoughtofvg.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://educationandstuff.wordpress.com/2012/01/25/exam-time/"
        }}>{`Exam Time`}</a>{` (educationandstuff.wordpress.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=3a3735c0-5800-4a6a-a537-73ae48b3f53b",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      